/**
 * Code Enforcement (Case) lifecycle status pill (♻️ clone of KORAStatusPill). A SEPARATE component
 * rather than widening StatusPill/KORAStatusPill/QuestionStatusPill because CaseStatus (CEOpen/
 * CENotice/CEReinspected/CEResolved/CEEscalated/CEClosed) is its own disjoint value set, not a
 * superset of either. Reuses the same token CSS vars by mapping each case status onto the nearest
 * concern token so the visual language stays one system.
 */
import { CASE_STATUS_LABELS, type CaseStatus } from "../api/types.js";

const CASE_STATUS_TOKEN: Record<CaseStatus, string> = {
  CEOpen: "new",
  CENotice: "acknowledged",
  CEReinspected: "inprogress",
  CEResolved: "resolved",
  CEEscalated: "closed",
  CEClosed: "closed",
};

export function CaseStatusPill({
  status,
  size = "md",
}: {
  status: CaseStatus;
  size?: "sm" | "md";
}): JSX.Element {
  const token = CASE_STATUS_TOKEN[status];
  return (
    <span
      className={`td-pill td-pill--${size}`}
      style={{
        color: `var(--td-status-${token}-fg)`,
        background: `var(--td-status-${token}-bg)`,
      }}
    >
      <span
        className="td-pill__dot"
        style={{ background: `var(--td-status-${token}-dot)` }}
        aria-hidden="true"
      />
      {CASE_STATUS_LABELS[status]}
    </span>
  );
}
